function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
import React, { useEffect, useRef, useState } from 'react';
import CommonPool from "../store/commonPool";
// import { guid } from '../utils';

var guid = function guid() {
  return 'axxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
export var EnhanceComponent = function EnhanceComponent(Component) {
  var EnhanceComps = function EnhanceComps(props) {
    var compsGuid = guid();
    var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      compsGuidTag = _useState2[0],
      setCompsGuidTag = _useState2[1];
    var title = props.title,
      schema = props.schema,
      isCommonComponent = props.isCommonComponent;
    var ref = useRef(null);
    useEffect(function () {
      var _props$schema, _props$schema2;
      // 组件作为基础组件被其他组件引用时，不进行初始化
      if (isCommonComponent) return;
      CommonPool.setRef(((_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : _props$schema.$id) || compsGuid, {
        title: title,
        ref: ref,
        type: schema === null || schema === void 0 ? void 0 : schema.type,
        widget: (schema === null || schema === void 0 ? void 0 : schema.widget) || (props === null || props === void 0 ? void 0 : props.guidWidget)
      });
      setCompsGuidTag(((_props$schema2 = props.schema) === null || _props$schema2 === void 0 ? void 0 : _props$schema2.$id) || compsGuid);
    }, [title, isCommonComponent]);
    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: ref,
      compsGuid: compsGuidTag
    }, props));
  };
  return EnhanceComps;
};